// Global types
import type {
  $ModelAction,
  $ModelName,
} from 'common.data';

export enum SocketEventType {
  modelChangedEvent = 'MODEL_CHANGED_EVENT',
}

export type $SocketEventParams = {
  [SocketEventType.modelChangedEvent]: {
    action: $ModelAction;
    ChampionshipId?: string;
    modelId: string;
    modelName: $ModelName;
    parentModelId?: string;
    RegattaId?: string;
    RegionId?: string;
    RegionSeasonId?: string;
  };
};
